import { useState, type FormEvent } from 'react';
import { Link } from 'react-router';
import { errorMessage, post } from '../api.js';
import { Field, Notice } from '../components/ui.js';
import { AuthLayout } from './AuthLayout.js';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await post('/auth/password/forgot', { email });
      setSent(true);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthLayout title="Forgot your password?">
      {sent ? (
        <Notice kind="ok">
          If an account exists for {email}, we sent it a link to choose a new password. The link
          works once, for a short time. Check your spam folder if it does not arrive.
        </Notice>
      ) : (
        <>
          <p className="muted">
            Enter the email of your account: we will send you a link to choose a new password.
          </p>
          {error && <Notice kind="error">{error}</Notice>}
          <form onSubmit={(e) => void submit(e)} className="vstack">
            <Field
              label="Email"
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button type="submit" className="btn primary block" disabled={busy}>
              Send the link
            </button>
          </form>
        </>
      )}
      <p className="small">
        <Link to="/sign-in">Back to sign in</Link>
      </p>
    </AuthLayout>
  );
}
